{
  "close": "Aizvērt"
}
